import React ,{ useEffect, useState} from 'react';
import { Modal } from 'react-bootstrap';
import { BsCheck } from 'react-icons/bs';
import { BiError } from 'react-icons/bi';
import { MdClose } from 'react-icons/md';
import DonutCharts from './DonutCharts';

const PrioritiydataScheduleDetails = ({ show, handleClose, priorityTable, taskSummary }) => {

    const [list , setList] = useState([]);
    useEffect(()=>{
        setList([...priorityTable])
    },[priorityTable])

    return (
        <>
            <Modal className='prioritytableshow ' size='xl' centered show={show} onHide={handleClose}>
                <Modal.Body className='p-4'>
                    <div className="row">
                        <div className="col-7">
                            <h5 className="anydetail-para">  Priority data schedule </h5>
                            <p className="mt-3 mb-0">No. of total task : {taskSummary.totalTasks} </p>
                            <p className="mb-0">No. of critical task : {taskSummary.criticalTasks} </p>
                            <p className="mb-0">No. of total hints taken : {taskSummary.hintTaken} </p>
                        </div>
                        <div className="col-5">
                            <div className='d-flex align-items-center justify-content-end'>
                                <div className='d-flex align-items-center justify-content-end ms-4'>
                                    <h6 className="mb-0">Performance Score</h6>
                                    <DonutCharts taskSummary={taskSummary} />
                                </div>
                            </div>
                            <p className="text-end">No. of wrong attempts/missed steps : <strong> {taskSummary.wrongAttempts} </strong></p>
                        </div>
                    </div>

                    <div className="table-responsive p-0 text-center">
                       {list?.length > 0 ?
                        <table className="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Sequence</th>
                                    <th>Standard </th>
                                    <th>Performed</th>
                                    <th>Hint Taken</th>
                                    <th>Time Spent</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                            {list.map((e,i)=>{
                                return(
                                    <tr key={i+1} >
                                        <td> {i+1} </td>
                                        <td> { e.isCritical && <BiError /> } {e.standard} </td>
                                        <td> { e.performed} </td>
                                        <td> { e.hint ? <BsCheck /> : <MdClose /> } </td>
                                        <td> { e.timeSpent} </td>
                                        <td> { e.status ? <BsCheck /> : <MdClose /> } </td>
                                    </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                        :
                        <p>No Task Found.</p>
                        }
                    </div>

                </Modal.Body>
            </Modal >
        </>
    )
}

export default PrioritiydataScheduleDetails
